import { Container } from 'pixi.js';

// Camera shake + boss-entry zoom — both apply transform to a target Container (the Pixi stage).
// Shake is a per-frame random offset; zoom is a 0.92→1.0 ease-out scale.
// Use `shake(mag, dur)` and `zoom(dur)` to trigger; call `tick(dt, W, H)` every frame.
export class Camera {
  private target: Container;
  private shakeMag = 0;
  private shakeT = 0;
  private zoomT = 0;
  private zoomDur = 0.6;

  constructor(target: Container) {
    this.target = target;
  }

  shake(mag: number, dur: number): void {
    this.shakeMag = Math.max(this.shakeMag, mag);
    this.shakeT = Math.max(this.shakeT, dur);
  }

  zoom(dur = 0.6): void {
    this.zoomT = dur;
    this.zoomDur = dur;
  }

  tick(dt: number, W: number, H: number): void {
    // Shake: per-frame random offset on stage
    if (this.shakeT > 0) {
      this.shakeT -= dt;
      const m = this.shakeMag * (this.shakeT > 0 ? 1 : 0);
      this.target.x = (Math.random() - 0.5) * m;
      this.target.y = (Math.random() - 0.5) * m;
      if (this.shakeT <= 0) {
        this.target.x = 0; this.target.y = 0;
        this.shakeMag = 0;
      }
    } else {
      this.target.x = 0; this.target.y = 0;
    }
    // Zoom: 0.92 → 1.0 ease-out scale, re-centered around screen midpoint
    if (this.zoomT > 0) {
      this.zoomT = Math.max(0, this.zoomT - dt);
      const t = 1 - this.zoomT / this.zoomDur;
      const eased = 1 - Math.pow(1 - t, 2);
      const scale = 0.92 + 0.08 * eased;
      this.target.scale.set(scale, scale);
      this.target.pivot.set(W / 2, H / 2);
      this.target.position.set(W / 2 + this.target.x, H / 2 + this.target.y);
    } else {
      // Always reset — the else-if(scale!==1) guard was never triggered because
      // scale reaches exactly 1.0 on the last zoom frame, leaving pivot stuck at
      // (W/2,H/2) and permanently shifting the stage.
      this.target.scale.set(1, 1);
      this.target.pivot.set(0, 0);
    }
  }
}
